/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as artistAdminActions from '../../actions/artistAdminActions';
import ArtistAdminService from '../../services/artistAdminService.js';
import ArtistService from '../../services/artistService';
import * as instrumentActions from '../../actions/instrumentActions';
import * as locationActions from '../../actions/locationActions';
import urls from '../../constants/urls.js';
import MetaTags from 'react-meta-tags';
import * as browserCheck from '../../utils/browserCheck.js';
import PageLoading from '../common/PageLoading';
import Error from '../common/Error';
import EditGeneral from './EditGeneral';
import EditGetToKnowMe from './EditGetToKnowMe';
import EditLookAtMe from './EditLookAtMe';
import EditHearMe from './EditHearMe';
import EditWatchMe from './EditWatchMe';
import EditSeeMe from './EditSeeMe';
import EditBuyMe from './EditBuyMe';
import settings from '../../constants/settings.js';
import EditFindMe from './EditFindMe';
import EditChatToMe from './EditChatToMe';

class ManageProfilePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
        };
    }

    componentWillMount() {   

    }

    componentDidMount() {   
        if(!window.google || !window.google.maps) {
            $.getScript(`https://maps.google.com/maps/api/js?key=${settings.GOOGLEPLACES_KEY}&libraries=places&sensor=false`);
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidUpdate(prevProps, prevState) {
    } 

    getTabClass(tabName) {
        let pageTabName = this.props.match.params.tabName || 'General';
        return tabName.toLowerCase() == pageTabName.toLowerCase() ? 'active':'';
    }

    getTabUrl(tabName) {
        if(tabName === 'General') {
            return '/Profile/Manage';
        }
        else {
            return `/Profile/Manage/${tabName}`;
        }
    }

    getTabContent() {
        if(!this.props.match.params.tabName || this.props.match.params.tabName.toLowerCase() == 'general') {
            return <EditGeneral profile={this.props.activeProfile} actions={this.props.actions} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'gettoknowme') {
            return <EditGetToKnowMe profile={this.props.activeProfile} actions={this.props.actions} countries={this.props.countries} createProfileError={this.props.createProfileError} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'lookatme') {
            return <EditLookAtMe profile={this.props.activeProfile} actions={this.props.actions} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'hearme') {
            return <EditHearMe profile={this.props.activeProfile} actions={this.props.actions} soundCloudToken={this.props.soundCloudToken} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'watchme') {
            return <EditWatchMe profile={this.props.activeProfile} actions={this.props.actions} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'seeme') {
            return <EditSeeMe profile={this.props.activeProfile} actions={this.props.actions} countries={this.props.countries} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'buyme') {
            return <EditBuyMe profile={this.props.activeProfile} actions={this.props.actions} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'findme') {
            return <EditFindMe profile={this.props.activeProfile} actions={this.props.actions} countries={this.props.countries} />;
        }
        else if(this.props.match.params.tabName.toLowerCase() == 'chattome') {
            return <EditChatToMe profile={this.props.activeProfile} actions={this.props.actions} />;
        }   
        /*also add manage me*/                                             
    }

    render() {   
        return (
            !this.props.user.activeProfile ?
                <Redirect to="/Profile/Create" />
                :
                <div id="content">
                    <div>
                        <MetaTags>
                            <title>Manage Profile - LoudUp</title>
                            <meta id="description" name="description" content="Manage your profile" />
                        </MetaTags>                        
                        <div className="main noclip">
                            <div className="container">
                                <div className="block-inner">
                                    <div className="signupbox">
                                        <div className="signhead">
                                            <h1 className="section-alt">Manage Profile: <strong>{this.props.activeProfile.DisplayName}</strong> ({ArtistService.getRoleTypeFriendlyName(this.props.activeProfile.RoleType)})</h1>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="tabs-stacked tabs-stacked-profile tabbed-content-profile">
                                                    <ul id="profileTabs" className="nav nav-tabs" role="tablist">
                                                        <li className={this.getTabClass('General')}>
                                                            <Link id="lnkGeneral" className="transition" to={this.getTabUrl('General')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-info" />
                                                                </svg>
                                                                <span className="title"> General Info</span>
                                                            </Link>
                                                        </li>

                                                        <li className={this.getTabClass('GetToKnowMe')}>
                                                            <Link id="lnkGetToKnowMe" className="transition" to={this.getTabUrl('GetToKnowMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-about" />
                                                                </svg>
                                                                <span className="title"> Get to know me</span>
                                                            </Link>
                                                        </li>

                                                        <li className={this.getTabClass('LookAtMe')}>
                                                            <Link id="lnkLookAtMe" className="transition" to={this.getTabUrl('LookAtMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-camera" />
                                                                </svg>
                                                                <span className="title"> Look at me</span>
                                                            </Link>
                                                        </li>

                                                        {this.props.activeProfile && this.props.activeProfile.RoleType !== 'Fan' && ArtistService.showMusic(this.props.activeProfile.RoleType)
                                                        ?
                                                            <li className={this.getTabClass('HearMe')}>
                                                                <Link id="lnkHearMe" className="transition" to={this.getTabUrl('HearMe')}>
                                                                    <svg className="icon icon-tab transition">
                                                                        <use xlinkHref="#icn-music" />
                                                                    </svg>
                                                                    <span className="title"> Hear me</span>
                                                                </Link>
                                                            </li> : null}
                                                        {this.props.activeProfile && this.props.activeProfile.RoleType !== 'Fan' && ArtistService.showVideos(this.props.activeProfile.RoleType)
                                                        ?
                                                            <li className={this.getTabClass('WatchMe')}>
                                                                <Link id="lnkWatchMe" className="transition" to={this.getTabUrl('WatchMe')}>
                                                                    <svg className="icon icon-tab transition">
                                                                        <use xlinkHref="#icn-tv" />
                                                                    </svg>
                                                                    <span className="title"> Watch me</span>
                                                                </Link>
                                                            </li> : null}
                                                        {this.props.activeProfile && this.props.activeProfile.RoleType !== 'Fan' && ArtistService.showGigs(this.props.activeProfile.RoleType)
                                                        ?
                                                            <li className={this.getTabClass('SeeMe')}>
                                                                <Link id="lnkSeeMe" className="transition" to={this.getTabUrl('SeeMe')}>
                                                                    <svg className="icon icon-tab transition">
                                                                        <use xlinkHref="#icn-calendar" />
                                                                    </svg>
                                                                    <span className="title"> See me</span>
                                                                </Link>
                                                            </li> : null}
                                                        {this.props.activeProfile && ArtistService.showBuyLinks(this.props.activeProfile.RoleType)
                                                        ?
                                                            <li className={this.getTabClass('BuyMe')}>
                                                                <Link id="lnkBuyMe" className="transition" to={this.getTabUrl('BuyMe')}>
                                                                    <svg className="icon icon-tab transition">
                                                                        <use xlinkHref="#icn-buy" />
                                                                    </svg>
                                                                    <span className="title"> Buy me</span>
                                                                </Link>
                                                            </li> : null}
                                                        {this.props.activeProfile && ArtistService.showFindMe(this.props.activeProfile.RoleType)
                                                        ?
                                                            <li className={this.getTabClass('FindMe')}>
                                                                <Link id="lnkFindMe" className="transition" to={this.getTabUrl('FindMe')}>
                                                                    <svg className="icon icon-tab transition">
                                                                        <use xlinkHref="#icn-location" />
                                                                    </svg>
                                                                    <span className="title"> Find me</span>
                                                                </Link>
                                                            </li> : null}
                                                        <li className={this.getTabClass('ChatToMe')}>
                                                            <Link id="lnkChatToMe" className="transition"  to={this.getTabUrl('ChatToMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-chat" />
                                                                </svg>
                                                                <span className="title"> Chat to me</span>
                                                            </Link>
                                                        </li>
                                                        {/*<li className={this.getTabClass('ManageMe')}>
                                                            <Link id="lnkManageMe" className="transition"  to={this.getTabUrl('ManageMe')}>
                                                                <svg className="icon icon-tab transition">
                                                                    <use xlinkHref="#icn-manageme" />
                                                                </svg>
                                                                <span className="title"> Manage me</span>
                                                            </Link>
                                                        </li>*/}
                                                    </ul>
                                                    <div className="tabcontent">
                                                        <div id="profilecontent" className="tab-pane fade active in">
                                                            {this.props.activeProfile ? this.getTabContent() :null}                                                
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

ManageProfilePage.propTypes = {    
    match: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    activeProfile: PropTypes.object.isRequired,
    genres: PropTypes.array,
    soundCloudToken: PropTypes.string,
    countries: PropTypes.array,
    createProfileError: PropTypes.string

};

function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        activeProfile: state.account.user.activeProfile,
        genres: state.genres,
        countries: state.location.countries,
        soundCloudToken: state.account.soundCloudToken,
        createProfileError: state.artists.createProfileError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //artist actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, artistAdminActions, locationActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProfilePage);